import React, { useState, createContext } from "react";
import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import secureLocalStorage from "react-secure-storage";
import { GET_USER, GET_AB } from "../gql/queries";
import { UPDATE_USER_AB, UPDATE_TOKEN } from "../gql/mutations";

export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const localUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  const localAbAuth = secureLocalStorage.getItem("abAuth") || {};

  const [refreshToken, setRefreshToken] = useState(
    localUser.refreshToken || null
  );
  const [token, setToken] = useState(localUser.token || null);
  const [userId, setUserId] = useState(localUser.userId || null);
  const [email, setEmail] = useState(localUser.email || null);
  const [abId, setAbId] = useState(localUser.abId || null);
  const [labId, setLabId] = useState(localUser.labId || null);
  const [abName, setAbName] = useState(localUser.abName || null);
  const [abLongName, setAbLongName] = useState(localUser.abLongName || null);
  const [firstName, setFirstName] = useState(localUser.firstName || null);
  const [lastName, setLastName] = useState(localUser.lastName || null);
  const [role, setRole] = useState(localAbAuth.role || null);
  const [auths, setAuths] = useState(localAbAuth.auths || null);
  const [expireTime, setExpireTime] = useState(localUser.expireTime || null);
  const [user, setUser] = useState(null);
  //Alerts
  const [alertOptions, setAlertOptions] = useState({});
  const [confirmAlert, setConfirmAlert] = useState(null);
  const [alertResponse, setAlertResponse] = useState({});
  const [alertData, setAlertData] = useState({});

  const [getUser, { loading, data, error }] = useLazyQuery(GET_USER, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setUser(data.login);
    },
  });

  const [updateUserAb, { loading: aLoading, error: aError, data: aData }] =
    useMutation(UPDATE_USER_AB, {
      onCompleted({ updateUserAb }) { },
    });

  const login = (
    refreshToken,
    token,
    userId,
    email,
    abId,
    abName,
    abLongName,
    firstName,
    lastName,
    role,
    auths,
    labId,
    expireTime,
    tokenExpiration
  ) => {
    setRefreshToken(refreshToken);
    setToken(token);
    setUserId(userId);
    setEmail(email);
    setAbId(abId);
    setAbName(abName);
    setAbLongName(abLongName);
    setFirstName(firstName);
    setLastName(lastName);
    setRole(role);
    setAuths(auths);
    setLabId(labId);
    setExpireTime(expireTime);
    localStorage.setItem(
      "currentUser",
      JSON.stringify({
        refreshToken,
        token,
        userId,
        email,
        abId,
        abName,
        abLongName,
        firstName,
        lastName,
        // role,
        labId,
        expireTime,
      })
    );
    secureLocalStorage.setItem("abAuth", {
      role,
      auths,
    });

    window.location.reload();
  };

  const getUserData = (email, password) => {
    getUser({
      variables: {
        email: email,
        password: password,
      },
    });
  };

  const logout = () => {
    console.log("logout");
    // return;
    setToken(null);
    setUserId(null);
    localStorage.removeItem("currentUser");
    secureLocalStorage.removeItem("abAuth");
    window.location.reload();
    // if (history) history.push("/login");
  };

  const changeAb = async (newAbId, newAbName, newAbLongName) => {
    // logout, then login to new ab
    // also change the ab on the user table to the new
    setAbId(newAbId);
    setAbName(newAbName);
    setAbLongName(newAbLongName);

    localStorage.setItem(
      "currentUser",
      JSON.stringify({
        refreshToken,
        token,
        userId,
        email,
        abId: newAbId,
        abName: newAbName,
        abLongName: newAbLongName,
        firstName,
        lastName,
        // role,
        expireTime,
      })
    );
    secureLocalStorage.setItem("abAuth", {
      role,
      auths,
    });

    const res = await updateUserAb({
      variables: {
        id: userId,
        abId: newAbId,
      },
    });
    if (aError) {
      console.log(aError);
      alert(aError);
    }
    return res;
  };

  const toggleConfirmAlert = () => {
    // setAlertTitle("Alert Title");
    setConfirmAlert(!confirmAlert);
  };

  return (
    <AuthContext.Provider
      value={{
        // ...this.state,
        refreshToken,
        token,
        userId,
        email,
        abId,
        abName,
        abLongName,
        firstName,
        lastName,
        role,
        auths,
        labId,
        expireTime,
        user,
        getUserData,
        login,
        logout,
        // updateTokenFunc,
        changeAb,
        confirmAlert,
        alertOptions,
        setAlertOptions,
        toggleConfirmAlert,
        alertResponse,
        setAlertResponse,
        alertData,
        setAlertData,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
